import React from 'react'
import ProductListPage from './ProductListPage'

const ProductsPage = () => <ProductListPage title="Products" />

export default ProductsPage
